import React from "react";
import { UserManagementStyled } from "./styled";
import {
  CustomBreadcrumb,
  CustomTableFooter,
  CreateUserModal,
  CustomModal,
  SessionExpiredModal,
} from "../../components";
import UserManagementAGGrid from "./UserManagementAGGrid";
import { API_URL } from "../../utils/Constants";
import SecureAPI from "../../SecureAPI";
import {
  USER_MANAGEMENT_CONSTANTS,
  API_CONTEXT_TYPE,
  ADMIN_TYPE,
} from "../../config/constants";

const UserManagement = () => {
  const [userDetails, setUserDetails] = React.useState([]);
  const [successCode, setSuccessCode] = React.useState(0);
  const [sessionExpired, setSessionExpired] = React.useState(false);
  const [pageNo, setPageNo] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);
  const [totalCount, setTotalCount] = React.useState(0);
  const [isCreateUser, setIsCreateUser] = React.useState(false);
  const [successModal, setSuccessModal] = React.useState(false);
  const [emailAddress, setEmailAddress] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [userRole, setUserRole] = React.useState("");
  const [validated, setValidated] = React.useState(false);
  const [failureModal, setFailureModal] = React.useState(false);
  const [failureMessage, setFailureMessage] = React.useState("");

  const role = localStorage.getItem("role");
  const isSalesAdmin = role === "SALESADMIN";

  const handleCreateUser = () => setIsCreateUser(true);
  const handleHideCreateUser = () => {
    setEmailAddress("");
    setFirstName("");
    setLastName("");
    setPassword("");
    setPhoneNumber("");
    setUserRole("");
    setValidated(false);
    setIsCreateUser(false);
  };
  const handleSucccessModal = () => {
    setSuccessModal(false);
    handleHideCreateUser();
  };

  const handleFailureModal = () => {
    setFailureModal(false);
    setFailureMessage("");
  };

  const sessionExpiredClose = () => {
    setSessionExpired(false);
    handleHideCreateUser();
  };

  const handleChange = (name, value) => {
    switch (name) {
      case "emailAddress":
        setEmailAddress(value);
        break;
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "password":
        setPassword(value);
        break;
      case "phoneNumber":
        setPhoneNumber(value);
        break;
      case "role":
        setUserRole(value);
        break;
      default:
        break;
    }
  };
  const handleSaveUser = async () => {
    try {
      setValidated(true);
      setIsCreateUser(false);
      if (
        emailAddress !== "" &&
        password != "" &&
        userRole != "" &&
        firstName != ""
      ) {
        let merchantIdGlobal = "";
        if (role == ADMIN_TYPE.SUPER_ADMIN) {
          merchantIdGlobal = localStorage.getItem("globalMerchantId");
        }
        if (role == ADMIN_TYPE.SCHOOL_ADMIN) {
          merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
        }
        let AuthUrl = localStorage.getItem("userProfile");
        let url = AuthUrl;
        let data = {
          emailAddress,
          firstName,
          lastName,
          password,
          phoneNumber,
          role: userRole,
          merchantId: merchantIdGlobal,
        };

        let authCode = localStorage.getItem("bearer");

        let headers = {
          "Content-Type": API_CONTEXT_TYPE,
          Authorization: authCode,
          Accept: API_CONTEXT_TYPE,
        };
        let api = new SecureAPI();
        await api.request(url, "POST", headers, data).then((response) => {
          if (
            response?.error?.status_code === 401 ||
            response?.status === "403"
          ) {
            setSessionExpired(true);
            return;
          }
          if (response?.status?.code == "Y") {
            setSuccessCode(response.status.code);
            setSuccessModal(true);
            getUserList();
          }
          if (response?.status?.code == "N") {
            setFailureModal(true);
            setFailureMessage(response.status.message);
          }
        });
      }
    } catch (err) {
      console.error("Error saving user:", err);
      if (
        !err.message ||
        (typeof err.message === "string" && err.message.includes("JSON"))
      ) {
        setSessionExpired(true);
        return;
      }
      if (err.code === "N") {
        setFailureModal(true);
        setFailureMessage(err.message);
      }
    } finally {
      setEmailAddress("");
      setFirstName("");
      setLastName("");
      setPassword("");
      setPhoneNumber("");
      setUserRole("");
      setValidated(false);
    }
  };
  const onPageSizeChanged = (event) => setPageSize(event?.target?.value);

  const onLeftArrow = () => setPageNo(pageNo - 1);

  const onRightArrow = () => setPageNo(pageNo + 1);

  React.useEffect(() => {
    getUserList();
  }, []);

  React.useEffect(() => {
    getUserList();
  }, [pageNo, pageSize]);

  const getUserList = () => {
    let roleData = localStorage.getItem("role");
    let merchantIdGlobal = "";
    if (roleData == "SUPERADMIN" || roleData == "SALESADMIN") {
      merchantIdGlobal = localStorage.getItem("globalMerchantId");
    }
    if (roleData == "SCHOOLADMIN") {
      merchantIdGlobal = localStorage.getItem("schoolAdminMerchantId");
    }

    let authCode = localStorage.getItem("bearer");
    let url = API_URL.GET_USERS + merchantIdGlobal;
    fetch(url, {
      method: "GET", // or 'PUT'
      headers: {
        Authorization: authCode,
        "Content-Type": "application/json",
        "Access-Control-Request-Method": "POST",
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.json();
      })
      .then((response) => {
        if (
          (response.error != undefined && response.error.status_code === 401) ||
          response.status === "403"
        ) {
          setSessionExpired(true);
          return;
        }
        setSuccessCode(response.status.code);
        setUserDetails(response.body);
        setTotalCount(response?.status?.message);
      })
      .catch((error) => {
        console.error("Error fetching user list:", error);
        setSessionExpired(true);
      });
  };
  return (
    <UserManagementStyled>
      <CustomBreadcrumb
        header={USER_MANAGEMENT_CONSTANTS.HEADER}
        currentPage={USER_MANAGEMENT_CONSTANTS.BREADCRUMB_USER_MANAGEMENT}
        isCreateUser={!isSalesAdmin}
        onCreateUser={handleCreateUser}
      >
        <div className="page-header py-0">
          <UserManagementAGGrid details={userDetails} func={getUserList} />
        </div>
        <div className="page-header py-0">
          <div className="table-footer-container">
            <CustomTableFooter
              pageNo={pageNo}
              pageSize={pageSize}
              totalCount={totalCount}
              onPageSizeChanged={onPageSizeChanged}
              onLeftArrow={onLeftArrow}
              onRightArrow={onRightArrow}
            />
          </div>
        </div>
        <CreateUserModal
          show={isCreateUser}
          handleHide={handleHideCreateUser}
          handleSave={handleSaveUser}
          emailAddress={emailAddress}
          firstName={firstName}
          lastName={lastName}
          password={password}
          phoneNumber={phoneNumber}
          role={userRole}
          handleChange={handleChange}
          validated={validated}
        />
        <CustomModal
          show={successCode && successModal}
          onHide={handleSucccessModal}
          title={USER_MANAGEMENT_CONSTANTS.SUCCESS_MESSAGE}
          message={" "}
        />
        <CustomModal
          show={failureModal}
          onHide={handleFailureModal}
          title={"Information"}
          message={failureMessage}
        />
        <SessionExpiredModal
          show={sessionExpired}
          onHide={sessionExpiredClose}
        />
      </CustomBreadcrumb>
    </UserManagementStyled>
  );
};

export default UserManagement;
